import React, { useEffect, useState } from 'react';
import { Field, CancelButton } from '@galop/component-library';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button } from 'reactstrap';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';

export const Settings = (props) => {
    const ls = require('local-storage');
    const { addToast } = useToasts();
    const [settings, setSettings] = useState({});
    const [resourceIsDirty, setResourceIsDirty] = useState(false);
    const [savingData, setSavingData] = useState(false);

    useEffect(() => resetSettings(), []);

    const resetSettings = () => setSettings({
        MinimumDate: ls("MinimumDate"),
        LockDate: ls("LockDate")
    });

    const updateResource = (field, value, resource) => {
        /* Set Value */
        resource[field] = value;

        setSettings({ ...resource });
        setResourceIsDirty(true);
    };

    const AllValid = () => {
        let isValid = true;

        isValid = isValid && !!settings.MinimumDate;

        return isValid;
    };

    const saveResource = () => {
        if (resourceIsDirty) {
            if (AllValid()) {
                makeCall(async (authHeader) => {
                    setSavingData(true);
                    await api.put(`api/utility/settings`, Object.keys(settings).map(setting => ({ name: setting, value: settings[setting] })), { headers: authHeader })
                        .catch(error => globalErrorHandler(error, addToast));

                    setResourceIsDirty(false);
                    setSavingData(false);

                    const results = await api('api/utility/settings', { headers: authHeader })
                        .catch(error => globalErrorHandler(error, addToast));

                    if (results && results.data) {
                        results.data.forEach(setting => ls(setting.name, setting.value));

                        resetSettings();
                    }

                });
            }
            else {
                addToast('Minimum Eviction Date is required.', { appearance: 'error', autoDismiss: true });
            }
        }
    };

    return (
        <fieldset className="mb-2">
            <legend>Global Settings</legend>
            <div className="border rounded p-2">
                <Row>
                    <Col>
                        <Field type="date" field="MinimumDate" fieldClassName={!!settings.MinimumDate ? '' : 'is-invalid'} value={settings.MinimumDate ? new Date(settings.MinimumDate) : null} label="Minimum Eviction Date" HideHelp onChange={(value) => updateResource('MinimumDate', value, settings)} />
                    </Col>
                    <Col>
                        <Field type="date" field="LockDate" value={settings.LockDate ? new Date(settings.LockDate) : null} label="Next Lockdown Date" HideHelp onChange={(value) => updateResource('LockDate', value, settings)} />
                    </Col>
                </Row>
                <div className="text-right mt-2">
                    <CancelButton color="light" className="border mx-1" disabled={!resourceIsDirty || savingData} ShowDropdown={resourceIsDirty} Close={() => {
                        resetSettings();
                        setResourceIsDirty(false);
                    }}>Cancel</CancelButton>
                    <Button color="success" disabled={!resourceIsDirty || savingData} onClick={() => {
                        saveResource();
                    }}>Save</Button>
                </div>
            </div>
        </fieldset>
    );
};


// WEBPACK FOOTER //
// ./src/components/Shared/Settings.js